<!--
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
-->
<template>
  <div class="website-main-container">
    <div class="page-header">
      <div class="page-title">导航管理</div>
    </div>
    <div class="page-body">
      <el-button size="mini" type="primary" round v-on:click="handlerEdit(null)"><i class="el-icon-plus"></i> 添加导航</el-button>
      <el-table ref="categoriesTable" :data="dataList" size="mini" highlight-current-row border header-row-class-name="datalist-header" row-key="id" default-expand-all :tree-props="{children: 'children'}" style="width: 100%; margin-top: 3px;">
        <el-table-column type="index" label="序号" width="45" align="center"></el-table-column>
        <el-table-column prop="name" label="导航名称" header-align="center"></el-table-column>
        <el-table-column prop="link" label="导航链接" align="center" width="400"></el-table-column>
        <el-table-column prop="sort" label="排序" align="center" width="45"></el-table-column>
        <el-table-column label="操作" width="70" align="center">
          <template v-slot:default="scope">
            <el-button size="mini" type="primary" circle v-on:click="handlerEdit(scope.row)"><i class="el-icon-edit"></i></el-button>
            <el-button size="mini" type="warning" circle v-on:click="handlerDelete(scope.$index, scope.row)"><i class="el-icon-delete"></i></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible="navigationDialogIsShow" width="400px" :close-on-click-modal="false" :modal-append-to-body="false" :append-to-body="true" :show-close="false">
      <div slot="title" class="dialog-title-container">
        <span class="title-label"><i class="el-icon-document"></i> 导航导航</span>
        <i style="float:right;" class="el-icon-error" @click="navigationDialogIsShow=false"></i>
      </div>
      <div class="dialog-search-container">
        <el-form label-width="80px">
          <el-form-item label="父级导航">
            <el-cascader size="mini" v-model="parentIds" :options="navigationOptions" :props="{ checkStrictly: true }" style="width: 100%;"></el-cascader>
          </el-form-item>
          <el-form-item label="导航名称">
            <el-input size="mini" placeholder="导航名称" v-model="navigation.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="链接地址">
            <el-input size="mini" placeholder="链接地址" v-model="navigation.link" clearable></el-input>
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number size="mini" v-model="navigation.sort" controls-position="right" :min="1" style="width: 100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="">
            <el-button size="small" type="success" icon="el-icon-finished" @click="handlerSave">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from './module.apis.js'
export default {
  name: 'website_navigation_list',
  data: () => {
    return {
      navigationDialogIsShow: false,
      // 导航列表
      dataList: [],
      navigationOptions: [],
      // 导航数据
      navigation: {},
      navigationIds: '0',
      emptyNavigation: {
        id: '0',
        parent_id: '0',
        parent_ids: '',
        name: '',
        value: '0',
        label: '',
        link: '',
        sort: 1
      },
      parentIds: ['0']
    }
  },
  mounted: function () {
    this.loadData()
  },
  methods: {
    loadData: function () {
      const _this = this
      _this.post(apis.getNavigations, _this.query, function (res) {
        const _json = res.data
        _this.dataList = _json.dataList
      })
    },
    // 编辑导航
    handlerEdit: function (_row) {
      const _this = this
      _this.post(apis.getNavigation, { id: _row === null ? '0' : _row.id }, function (res) {
        const _json = res.data
        const rootNavigation = JSON.parse(JSON.stringify(_this.emptyNavigation))
        rootNavigation.label = '一级导航'
        _this.navigationOptions = _json.navigationOptions
        _this.navigationOptions.unshift(rootNavigation)
        
        if (_row === null)
          _this.navigation = JSON.parse(JSON.stringify(_this.emptyNavigation))
        else {
          _this.navigation = _row
          _this.parentIds = _this.navigation.parent_ids.split(',')
        }
        _this.navigationDialogIsShow = true
      })
    },
    handlerDelete: function (_index, _row) {
      const _this = this
      _this.$confirm('此操作将删除该导航, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.post(apis.delNavigations, { ids: _row.id }, function (res) {
          const _json = res.data
          if (_json.status === 'ok') {
            _this.$message({
              message: '操作成功',
              type: 'success'
            })
            _this.loadData()
          } else {
            _this.$message.error('操作失败')
          }
        })
      })
    },
    // 保存导航
    handlerSave: function (_id) {
      const _this = this
      const _length = _this.parentIds.length
      if (_length > 0) {
        _this.navigation.parent_id = _this.parentIds[_length - 1]
        _this.navigation.parent_ids = _this.parentIds.join(',')
      }
      _this.post(apis.saveNavigation, _this.navigation, function (res) {
        const _json = res.data
        if (_json.status === 'ok') {
          _this.$message({
            message: '操作成功',
            type: 'success'
          })
          _this.loadData()
          _this.navigationDialogIsShow = false
        } else {
          _this.$message.error('操作失败')
        }
      })
    }
  }
}
</script>